import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useCallback, useEffect, useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { defineMessages, T } from '@sm/intl';
import { visuallyHidden, uniqueId } from '@wds/utils';
import { c as classnames, l as lodash_unescape, r as reactErrorBoundary_umd } from './vendor-1a792cb6.js';
import { sanitizeString } from '@sm/utils';
createUseStyles(function (theme) {
  var _a;

  return {
    button: {
      color: theme.nextButton.color,
      backgroundColor: theme.nextButton.backgroundColor,
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      fontSize: 15,
      border: [1, 'solid', 'transparent'],
      borderRadius: 2,
      padding: [1, 6],
      maxWidth: '100%',
      minWidth: 60,
      minHeight: 40,
      cursor: 'pointer',
      overflowWrap: 'break-word'
    }
  };
});
var useStyles$d = createUseStyles({
  visuallyHidden: visuallyHidden
});

var VisuallyHidden = function VisuallyHidden(_ref) {
  var children = _ref.children,
      Element = _ref.element;

  var _useStyles$d = useStyles$d(),
      visuallyHidden = _useStyles$d.visuallyHidden;

  return React.createElement(Element, {
    className: visuallyHidden
  }, children);
};

var useStyles$c = createUseStyles({
  paddingBox: function paddingBox(_ref2) {
    var padding = _ref2.padding;
    return {
      paddingTop: (padding === null || padding === void 0 ? void 0 : padding.top) || 0,
      paddingBottom: (padding === null || padding === void 0 ? void 0 : padding.bottom) || 0,
      paddingLeft: (padding === null || padding === void 0 ? void 0 : padding.left) || 0,
      paddingRight: (padding === null || padding === void 0 ? void 0 : padding.right) || 0
    };
  }
});

var QuestionSpacing = function QuestionSpacing(_ref3) {
  var padding = _ref3.padding,
      children = _ref3.children;

  var _useStyles$c = useStyles$c({
    padding: padding
  }),
      paddingBox = _useStyles$c.paddingBox;

  return React.createElement("div", {
    className: paddingBox
  }, children);
};

var useStyles$b = createUseStyles({
  footerRow: function footerRow(_ref4) {
    var hasFooterPadding = _ref4.hasFooterPadding;
    return {
      paddingTop: hasFooterPadding ? 20 : 0
    };
  },
  containerStyles: function containerStyles(_ref5) {
    var clickShield = _ref5.clickShield;
    return {
      position: 'relative',
      opacity: clickShield ? '0.5' : '1',
      transition: 'opacity 500ms ease-out',
      pointerEvents: clickShield ? 'none' : 'auto'
    };
  },
  errorRow: {
    marginBottom: 10
  },
  formReset: {
    border: 0,
    minWidth: 0
  },
  headerRow: {
    marginBottom: 24
  }
});
var COPY$2 = defineMessages({
  QUESTION_TITLE: {
    id: 'ResponseQuestion.QUESTION_TITLE',
    defaultMessage: 'Question Title',
    description: '[Type: Label][Vis: low] - question landmark for screen readers only'
  }
});

var QuestionFieldLayoutTemplate = function QuestionFieldLayoutTemplate(_ref6) {
  var footer = _ref6.footer,
      hasFooterPadding = _ref6.hasFooterPadding,
      children = _ref6.children,
      clickShield = _ref6.clickShield,
      error = _ref6.error,
      id = _ref6.id,
      padding = _ref6.padding,
      title = _ref6.title,
      onSubmit = _ref6.onSubmit,
      props = _objectWithoutProperties(_ref6, ["footer", "hasFooterPadding", "children", "clickShield", "error", "id", "padding", "title", "onSubmit"]);

  var _useStyles$b = useStyles$b({
    hasFooterPadding: hasFooterPadding,
    clickShield: clickShield
  }),
      footerRow = _useStyles$b.footerRow,
      containerStyles = _useStyles$b.containerStyles,
      formReset = _useStyles$b.formReset,
      errorRow = _useStyles$b.errorRow,
      headerRow = _useStyles$b.headerRow;

  var containerRef = useRef(null);
  var handleKeydown = useCallback(function (event) {
    if (event.key === 'Enter') {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }
  }, [onSubmit]);
  useEffect(function () {
    var container = containerRef.current;
    container === null || container === void 0 ? void 0 : container.addEventListener('keydown', handleKeydown);
    return function () {
      return container === null || container === void 0 ? void 0 : container.removeEventListener('keydown', handleKeydown);
    };
  }, [containerRef, handleKeydown]);
  return React.createElement("div", Object.assign({
    ref: containerRef,
    id: id
  }, props, {
    className: containerStyles
  }), React.createElement(VisuallyHidden, {
    element: "h3"
  }, React.createElement(T, {
    desc: COPY$2.QUESTION_TITLE
  })), React.createElement(QuestionSpacing, {
    padding: padding
  }, React.createElement("fieldset", {
    className: formReset
  }, React.createElement("legend", {
    className: headerRow
  }, error && React.createElement("div", {
    className: errorRow
  }, error), title), children), footer && React.createElement("div", {
    className: footerRow
  }, footer)));
};
/**
 * Calculate the max number of children each column can be filled in the layout
 * @param columns number of columns
 * @param total total child count
 * @description Based on the current implementation in production (as of Jan 20, 2021),
 * - if columns = 1, the max number of children per column = total (render all children vertically)
 * - if columns > 1, the max number of children per column = (total / columns) + 1
 */


var calculateMaxNumOfChildrenPerColumn = function calculateMaxNumOfChildrenPerColumn(columns, total) {
  if (columns === 1) {
    return total;
  }

  var childrenPerColumn = total / columns;

  if (childrenPerColumn % 1 === 0) {
    return childrenPerColumn;
  }

  return Math.floor(childrenPerColumn) + 1;
};
/**
 * Divide the children array into slices for rendering
 * @param childrenArr - children array
 * @param childrenPerSlice - number of children per slice
 * @example
 * childrenArr = [option1, option2, option3, option4, option5]
 * childrenPerSlice = 2
 * output: [[option1, option2], [option3, option4], [option5]]
 */


var sliceChildren = function sliceChildren(childrenArr, childrenPerSlice) {
  var index = 0;
  var result = [];

  while (index < childrenArr.length) {
    result.push(childrenArr.slice(index, index + childrenPerSlice));
    index += childrenPerSlice;
  }

  return result;
};

var useStyles$a = createUseStyles(function (theme) {
  var _ref7;

  return _ref7 = {
    containerVertical: {
      display: 'initial'
    },
    containerHorizontal: {
      display: 'block'
    },

    /** shared between horizontal and vertical columns */
    column: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    columnHorizontal: {},

    /** Horizontal Column that adjust width to content width */
    columnHorizontalAutoAdjust: {
      width: 'auto'
    }
  }, _defineProperty(_ref7, "@media (min-width: ".concat(theme.breakpoints.xsMin, ")"), {
    containerVertical: {
      display: 'flex'
    },
    containerHorizontal: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  }), _defineProperty(_ref7, "@media only screen and (min-width: ".concat(theme.breakpoints.lgMin, ")"), {
    columnHorizontal: {
      width: '19%'
    }
  }), _defineProperty(_ref7, "@media (min-width: ".concat(theme.breakpoints.smMin, ") and (max-width: ").concat(theme.breakpoints.mdMax, ")"), {
    columnHorizontal: {
      width: '24%'
    }
  }), _defineProperty(_ref7, "@media only screen and (max-width: ".concat(theme.breakpoints.xxsMax, ")"), {
    columnHorizontal: {
      width: '100%',
      display: 'block'
    },
    columnHorizontalAutoAdjust: {
      width: '100%',
      display: 'block'
    }
  }), _ref7;
});

var QuestionAnswerLayoutTemplate = function QuestionAnswerLayoutTemplate(_ref8) {
  var children = _ref8.children,
      _ref8$columns = _ref8.columns,
      columns = _ref8$columns === void 0 ? 1 : _ref8$columns,
      other = _ref8.other,
      noneOfTheAbove = _ref8.noneOfTheAbove,
      _ref8$adjustToContent = _ref8.adjustToContent,
      adjustToContent = _ref8$adjustToContent === void 0 ? false : _ref8$adjustToContent;

  var _useStyles$a = useStyles$a({
    columns: columns,
    adjustToContent: adjustToContent
  }),
      containerVertical = _useStyles$a.containerVertical,
      containerHorizontal = _useStyles$a.containerHorizontal,
      column = _useStyles$a.column,
      columnHorizontal = _useStyles$a.columnHorizontal,
      columnHorizontalAutoAdjust = _useStyles$a.columnHorizontalAutoAdjust;

  var isHorizontal = columns === 'horizontal';
  /* Based on the columns config, divide the question answers
    (children of this component) into column groups for rendering.
       The reason we need to do this is when there are multiple columns,
    the answers are listed vertically instead of horizontally.
    For example:
    If there are 3 answers and 2 columns,
    Then the ordering will be:
    Answer 1    Answer 3
    Answer 2
       NOT:
    Answer 1    Answer 2
    Answer 3
    * though `horizontal` uses this
    
  */

  var columnGroups = useMemo(function () {
    var totalChildren = React.Children.count(children);
    var totalColumns = columns === 'horizontal' ? totalChildren : columns;
    var childrenArray = React.Children.toArray(children);
    var answersPerColumn = columns === 'horizontal' ? 1 : calculateMaxNumOfChildrenPerColumn(totalColumns, totalChildren);
    return sliceChildren(childrenArray, answersPerColumn);
  }, [children, columns]);
  var columnClassNames = isHorizontal ? [column, adjustToContent ? columnHorizontalAutoAdjust : columnHorizontal] : column;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: isHorizontal ? containerHorizontal : containerVertical
  }, columnGroups.map(function (col, columnIndex) {
    return React.createElement("div", {
      key: "col-".concat(columnIndex + 1),
      className: classnames(columnClassNames),
      "data-testid": "answer-layout-column"
    }, col.map(function (cell, cellIndex) {
      return React.createElement("div", {
        key: "cell-".concat(cellIndex + 1),
        "data-testid": "answer-layout-cell"
      }, cell);
    }));
  })), other && React.createElement("div", null, other), noneOfTheAbove && React.createElement("div", null, noneOfTheAbove));
};

var calculateQuestionWidthPercentage = function calculateQuestionWidthPercentage(numOfQuestions) {
  var width = 100 / numOfQuestions;

  if (width % 1) {
    return "".concat(width.toFixed(2), "%");
  }

  return "".concat(width, "%");
};

createUseStyles(function (theme) {
  var _ref12;

  return _ref12 = {
    gridRow: {
      maxWidth: '100%',
      marginBottom: '40px'
    },
    gridItem: function gridItem(_ref9) {
      var numOfQuestions = _ref9.numOfQuestions,
          maxQuestionsPerRow = _ref9.maxQuestionsPerRow;
      return _objectSpread({
        marginBottom: '30px'
      }, numOfQuestions > 1 && maxQuestionsPerRow > 1 ? {
        paddingRight: '20px',
        width: calculateQuestionWidthPercentage(Math.min(maxQuestionsPerRow, numOfQuestions))
      } : {
        width: '100%'
      });
    }
  }, _defineProperty(_ref12, "@media (max-width: ".concat(theme.breakpoints.xsMax, ")"), {
    gridItem: {
      paddingRight: "0 !important",
      width: '100% !important'
    }
  }), _defineProperty(_ref12, "@media (min-width: ".concat(theme.breakpoints.smMin, ")"), {
    gridRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }
  }), _defineProperty(_ref12, "@media (min-width: ".concat(theme.breakpoints.smMin, ") and (max-width: ").concat(theme.breakpoints.mdMax, ")"), {
    // TODO: RAWR-735 bug in JSS - always applies the last item,
    // so if the last has maxQuestionsPerRow > 1 all gridItem are 50% wide
    gridItem: function gridItem(_ref10) {
      var maxQuestionsPerRow = _ref10.maxQuestionsPerRow;
      return maxQuestionsPerRow > 1 ? {
        paddingRight: '20px',
        // two columns layout
        width: '50%'
      } : {
        width: '100%'
      };
    }
  }), _defineProperty(_ref12, "@media (min-width: ".concat(theme.breakpoints.lgMin, ")"), {
    gridItem: function gridItem(_ref11) {
      var numOfQuestions = _ref11.numOfQuestions;
      return numOfQuestions > 1 ? {
        paddingRight: '20px'
      } : {};
    }
  }), _ref12;
});
var textReset = {
  margin: 0
};
var inlineSpacing = {
  marginRight: '0.25em'
};
var useStyles$9 = createUseStyles(function (theme) {
  var _theme$questionTitle = theme.questionTitle,
      fontSize = _theme$questionTitle.fontSize,
      questionTitleFormatting = _objectWithoutProperties(_theme$questionTitle, ["fontSize"]);

  var questionTitleFontSize = theme.isAccessible ? '22px' : fontSize !== null && fontSize !== void 0 ? fontSize : {};
  return {
    addonContainer: {
      display: 'inline-block',
      margin: [0, 5],
      verticalAlign: 'text-bottom'
    },
    container: {
      position: 'relative'
    },
    questionNumber: inlineSpacing,
    questionTitle: function questionTitle(_ref13) {
      var useDefaultFrontSize = _ref13.useDefaultFrontSize;

      var _a;

      return _objectSpread(_objectSpread(_objectSpread({}, textReset), questionTitleFormatting), {}, {
        color: ((_a = theme.questionTitle) === null || _a === void 0 ? void 0 : _a.color) || theme.questionColor,
        fontSize: useDefaultFrontSize && !theme.isAccessible ? theme.fontSize.body : questionTitleFontSize,
        lineHeight: 1.25,
        whiteSpace: 'normal',
        wordWrap: 'break-word'
      });
    },
    requiredAsterisk: _objectSpread(_objectSpread({}, inlineSpacing), {}, {
      display: 'inline-block'
    })
  };
});
/* eslint-disable @typescript-eslint/naming-convention */

var listSpacing = {
  margin: [16, 0],
  padding: [0, 0, 0, 40]
};
var mediaReset = {
  border: 0,
  maxWidth: '100%'
};
var useStyles$8 = createUseStyles({
  richTextContent: {
    // Typography
    '& a': {
      // Links are not themed by default. Users must select a link color in the editor
      color: 'blue',
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer'
      },
      '&:focus': {
        outline: 'currentColor auto 1px'
      }
    },
    '& ol': _objectSpread(_objectSpread({}, listSpacing), {}, {
      listStyleType: 'decimal'
    }),
    '& ul': _objectSpread(_objectSpread({}, listSpacing), {}, {
      listStyle: 'disc outside none',
      '& ul li': {
        listStyle: 'circle'
      }
    }),
    '& p': {
      margin: [13, 0]
    },
    '& b': {
      fontWeight: 'bold'
    },
    '& strong': {
      fontWeight: 'bold'
    },
    '& em': {
      fontStyle: 'italic'
    },
    '& i': {
      fontStyle: 'italic'
    },
    '& big': {
      fontSize: 'larger'
    },
    '& small': {
      fontSize: 'smaller'
    },
    '& sup': {
      fontSize: '75%',
      lineHeight: 0,
      position: 'relative',
      top: '-0.5em',
      verticalAlign: 'baseline'
    },
    // Media embeds
    '& iframe': mediaReset,
    '& img': _objectSpread(_objectSpread({}, mediaReset), {}, {
      height: 'auto',
      '-ms-interpolation-mode': 'bicubic'
    })
  }
}); // Support iframe video embeds and their matching attributes

var sanitizeOptions = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'sandbox', 'scrolling']
};

var RichText = function RichText(_ref14) {
  var Element = _ref14.element,
      text = _ref14.text;

  var _useStyles$ = useStyles$8(),
      richTextContent = _useStyles$.richTextContent;

  return React.createElement(Element, {
    className: richTextContent,
    dangerouslySetInnerHTML: {
      __html: sanitizeString(text, sanitizeOptions)
    }
  });
};

var QuestionTitle = function QuestionTitle(_ref15) {
  var addon = _ref15.addon,
      heading = _ref15.heading,
      id = _ref15.id,
      number = _ref15.number,
      numbered = _ref15.numbered,
      required = _ref15.required,
      _ref15$useDefaultFron = _ref15.useDefaultFrontSize,
      useDefaultFrontSize = _ref15$useDefaultFron === void 0 ? false : _ref15$useDefaultFron,
      props = _objectWithoutProperties(_ref15, ["addon", "heading", "id", "number", "numbered", "required", "useDefaultFrontSize"]);

  var _useStyles$2 = useStyles$9({
    useDefaultFrontSize: useDefaultFrontSize
  }),
      addonContainer = _useStyles$2.addonContainer,
      container = _useStyles$2.container,
      questionNumber = _useStyles$2.questionNumber,
      questionTitle = _useStyles$2.questionTitle,
      requiredAsterisk = _useStyles$2.requiredAsterisk;

  return React.createElement("h4", Object.assign({
    id: id,
    className: classnames(container, questionTitle)
  }, props), required && React.createElement("span", {
    "aria-hidden": true,
    className: requiredAsterisk
  }, "*"), numbered && React.createElement("span", {
    className: questionNumber
  }, number, "."), React.createElement(RichText, {
    element: "span",
    text: heading
  }), addon && React.createElement("span", {
    className: addonContainer
  }, addon));
};

createUseStyles(function (theme) {
  var _a;

  return {
    icon: {
      backgroundClip: 'padding-box',
      backgroundColor: theme.primaryAccentColor,
      borderRadius: 3,
      color: theme.secondaryAccentColor,
      fontSize: theme.fontSize.body,
      padding: [0, 5]
    },
    iconWrapper: {
      marginRight: 5
    },
    validationMessage: {
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      lineHeight: 1.5,
      color: theme.questionBody.color,
      fontWeight: theme.fontWeight.light,
      fontSize: theme.fontSize.body
    }
  };
});
var useStyles$7 = createUseStyles(function (theme) {
  var _a;

  return _defineProperty({
    textareaStyles: _objectSpread(_objectSpread({
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      fontSize: '18px',
      lineHeight: '1.15em',
      padding: '6px 60px 6px 6px',
      maxWidth: '100%',
      color: theme.questionBody.color,
      outlineColor: theme.primaryAccentColor,
      transition: 'all 0.1s linear',
      verticalAlign: 'top',
      textSizeAdjust: 'auto'
    }, theme.isAccessible ? {
      fontWeight: 500,
      opacity: 1,
      border: "1px solid ".concat(theme.answerColor),
      backgroundColor: '#fff'
    } : {
      fontWeight: 300,
      backgroundColor: theme.input.bgColor,
      border: '0'
    }), {}, {
      '&:focus': {
        borderColor: theme.input.activeColor,
        borderRadius: '2px'
      },
      '&:focus, &:hover': theme.isAccessible ? {
        // should be there but was broken
        // https://code.corp.surveymonkey.com/devmonkeys/smlib.surveytemplates/blob/main/smlib/surveytemplates/themes_v3/base_css.jinja2#L1094-L1097
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 7)'
      } : {},
      '&:disabled': _objectSpread({
        boxShadow: 'none'
      }, theme.isAccessible ? {} : {
        borderColor: 'transparent',
        opacity: 0.5
      })
    })
  }, "@media only screen and (max-width: ".concat(theme.breakpoints.mdMax, ")"), {
    textareaStyles: {
      fontSize: '16px'
    }
  });
}); // Custom textarea component for Response.

var TextArea = function TextArea(_ref17) {
  var placeholder = _ref17.placeholder,
      disabled = _ref17.disabled,
      rows = _ref17.rows,
      cols = _ref17.cols,
      id = _ref17.id,
      name = _ref17.name,
      defaultValue = _ref17.defaultValue,
      labelId = _ref17.labelId,
      errorId = _ref17.errorId,
      _ref17$required = _ref17.required,
      required = _ref17$required === void 0 ? false : _ref17$required,
      onChange = _ref17.onChange,
      onBlur = _ref17.onBlur,
      onFocus = _ref17.onFocus;

  var _useStyles$3 = useStyles$7(),
      textareaStyles = _useStyles$3.textareaStyles;

  return React.createElement("textarea", {
    className: textareaStyles,
    placeholder: placeholder,
    disabled: disabled,
    rows: rows,
    cols: cols,
    id: id,
    name: name,
    defaultValue: defaultValue,
    "aria-labelledby": labelId,
    "aria-describedby": errorId,
    "aria-required": required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    spellCheck: true
  });
};

var useStyles$6 = createUseStyles(function (theme) {
  var _a;

  return _defineProperty({
    inputStyles: _objectSpread(_objectSpread({
      fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
      fontSize: '18px',
      lineHeight: '1.5em',
      height: function height(_ref18) {
        var autoHeight = _ref18.autoHeight;
        return autoHeight ? {} : '50px';
      },
      padding: '6px',
      maxWidth: '100%',
      color: theme.questionBody.color,
      transition: 'all 0.1s linear'
    }, theme.isAccessible ? {
      fontWeight: 500,
      opacity: 1,
      border: theme.isAccessible ? "1px solid ".concat(theme.answerColor) : '0',
      backgroundColor: '#fff'
    } : {
      fontWeight: 300,
      backgroundColor: theme.input.bgColor,
      border: '0'
    }), {}, {
      '&:focus': {
        outline: 'none',
        borderColor: theme.input.activeColor,
        borderRadius: '2px'
      },
      '&:focus, &:hover': _objectSpread({}, theme.isAccessible ? {
        // should be there but was broken
        // https://code.corp.surveymonkey.com/devmonkeys/smlib.surveytemplates/blob/main/smlib/surveytemplates/themes_v3/base_css.jinja2#L1094-L1097
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 7)'
      } : {}),
      '&:disabled': _objectSpread({
        boxShadow: 'none'
      }, theme.isAccessible ? {} : {
        borderColor: 'transparent',
        opacity: 0.5
      })
    })
  }, "@media only screen and (max-width: ".concat(theme.breakpoints.mdMax, ")"), {
    inputStyles: {
      fontSize: '16px'
    }
  });
});

var TextInput = function TextInput(_ref20) {
  var defaultValue = _ref20.defaultValue,
      disabled = _ref20.disabled,
      errorId = _ref20.errorId,
      id = _ref20.id,
      labelId = _ref20.labelId,
      name = _ref20.name,
      onBlur = _ref20.onBlur,
      onChange = _ref20.onChange,
      onFocus = _ref20.onFocus,
      placeholder = _ref20.placeholder,
      _ref20$required = _ref20.required,
      required = _ref20$required === void 0 ? false : _ref20$required,
      _ref20$autoHeight = _ref20.autoHeight,
      autoHeight = _ref20$autoHeight === void 0 ? false : _ref20$autoHeight,
      _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 50 : _ref20$size;

  var _useStyles$4 = useStyles$6({
    autoHeight: autoHeight
  }),
      inputStyles = _useStyles$4.inputStyles;

  return React.createElement("input", {
    type: "text",
    className: inputStyles,
    placeholder: placeholder,
    disabled: disabled,
    size: size,
    id: id,
    name: name,
    defaultValue: defaultValue,
    onChange: onChange,
    "aria-labelledby": labelId,
    onBlur: onBlur,
    onFocus: onFocus,
    "aria-describedby": errorId,
    "aria-required": required
  });
};

var QuizCorrectIcon = function QuizCorrectIcon(_ref21) {
  var _ref21$isAriaHidden = _ref21.isAriaHidden,
      isAriaHidden = _ref21$isAriaHidden === void 0 ? false : _ref21$isAriaHidden;
  return React.createElement("svg", {
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    version: "1.1",
    "data-testid": "quiz-result-correct-icon",
    "aria-hidden": isAriaHidden
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-257, -338.75)",
    fill: "#F2FAE8"
  }, React.createElement("g", {
    id: "check-correct",
    transform: "translate(254, 334)"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M4,10.3259737 C4,10.4757908 4.04494448,10.5956428 4.13483478,10.6855331 L7.33716071,13.8990952 C7.42705101,13.9889855 7.55626637,14.069511 7.72481069,14.1406742 C7.893355,14.2118373 8.04504261,14.2474184 8.17987806,14.2474184 L8.78663455,14.2474184 C9.07877802,14.2474184 9.359681,14.1313118 9.6293519,13.8990952 L16.4160356,7.08993903 C16.5059259,7.00004873 16.5508704,6.88206948 16.5508704,6.73599774 C16.5508704,6.589926 16.5059259,6.47194675 16.4160356,6.38205645 L15.1575777,5.13483478 C15.0676874,5.04494448 14.9515809,5 14.8092545,5 C14.6669282,5 14.5433309,5.04494448 14.4384589,5.13483478 L8.85405194,10.7529504 C8.76416164,10.8428407 8.6443097,10.8877852 8.49449253,10.8877852 C8.34467537,10.8877852 8.22482343,10.8428407 8.13493313,10.7529504 L6.11241149,8.7304288 C6.02252119,8.6405385 5.90266926,8.59559403 5.75285209,8.59559403 C5.60303492,8.59559403 5.48318299,8.6405385 5.39329269,8.7304288 L4.13483478,9.96641425 C4.04494448,10.0563045 4,10.1761565 4,10.3259737 L4,10.3259737 Z"
  }))))));
};

var QuizWrongIcon = function QuizWrongIcon(_ref22) {
  var _ref22$isAriaHidden = _ref22.isAriaHidden,
      isAriaHidden = _ref22$isAriaHidden === void 0 ? false : _ref22$isAriaHidden;
  return React.createElement("svg", {
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: "1.1",
    "data-testid": "quiz-result-wrong-icon",
    "aria-hidden": isAriaHidden
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0.281690141,9.92648775 C0.281690141,10.187088 0.368074254,10.4068447 0.54084507,10.5857643 L1.25070423,11.3208868 C1.42347504,11.4998064 1.63567949,11.5892649 1.88732394,11.5892649 C2.13896839,11.5892649 2.35117285,11.4998064 2.52394366,11.3208868 L5.03661972,8.71878646 C5.20939054,8.53986686 5.42159499,8.4504084 5.67323944,8.4504084 C5.92488389,8.4504084 6.1446,8.53986686 6.33239437,8.71878646 L8.82253521,11.3208868 C8.99530603,11.4998064 9.20751048,11.5892649 9.45915493,11.5892649 C9.71079938,11.5892649 9.93051549,11.4998064 10.1183099,11.3208868 L10.828169,10.5857643 C11.0009398,10.4068447 11.0873239,10.187088 11.0873239,9.92648775 C11.0873239,9.66588746 11.0009398,9.43835181 10.828169,9.24387398 L8.31549296,6.66511085 C8.14272214,6.47063302 8.05633803,6.24698687 8.05633803,5.99416569 C8.05633803,5.74134452 8.14272214,5.51769837 8.31549296,5.32322054 L10.828169,2.74445741 C11.0009398,2.54997958 11.0873239,2.32244393 11.0873239,2.06184364 C11.0873239,1.80124335 11.0009398,1.5814867 10.828169,1.40256709 L10.1183099,0.667444574 C9.93051549,0.488524971 9.71079938,0.399066511 9.45915493,0.399066511 C9.20751048,0.399066511 8.99530603,0.488524971 8.82253521,0.667444574 L6.33239437,3.26954492 C6.1446,3.44846453 5.92488389,3.53792299 5.67323944,3.53792299 C5.42159499,3.53792299 5.20939054,3.44846453 5.03661972,3.26954492 L2.52394366,0.667444574 C2.35117285,0.488524971 2.13896839,0.399066511 1.88732394,0.399066511 C1.63567949,0.399066511 1.42347504,0.488524971 1.25070423,0.667444574 L0.54084507,1.40256709 C0.368074254,1.5814867 0.281690141,1.80124335 0.281690141,2.06184364 C0.281690141,2.32244393 0.368074254,2.54997958 0.54084507,2.74445741 L3.05352113,5.32322054 C3.22629194,5.51769837 3.31267606,5.74134452 3.31267606,5.99416569 C3.31267606,6.24698687 3.22629194,6.47063302 3.05352113,6.66511085 L0.54084507,9.24387398 C0.368074254,9.43835181 0.281690141,9.66588746 0.281690141,9.92648775 L0.281690141,9.92648775 Z",
    fill: "#FFFFFF"
  })));
};

var icons = {
  correct: QuizCorrectIcon,
  wrong: QuizWrongIcon
};
var useStyles$5 = createUseStyles({
  srOnly: visuallyHidden
});
var COPY$1 = defineMessages({
  CORRECT: {
    id: 'SrText.CORRECT',
    defaultMessage: 'Correct',
    description: '[Type: label][Vis: med] - the answer was correct'
  },
  INCORRECT: {
    id: 'SrText.INCORRECT',
    defaultMessage: 'Incorrect',
    description: '[Type: label][Vis: med] - the answer was incorrect '
  }
});

var SrText = function SrText(_ref23) {
  var icon = _ref23.icon;

  var _useStyles$5 = useStyles$5(),
      srOnly = _useStyles$5.srOnly;

  var TranslatedText = function TranslatedText() {
    return React.createElement(T, {
      desc: icon === 'correct' ? COPY$1.CORRECT : COPY$1.INCORRECT
    });
  };

  return React.createElement("div", {
    className: srOnly
  }, icon ? React.createElement(TranslatedText, null) : React.createElement(React.Fragment, null));
};

var useStyles$4 = createUseStyles(function (theme) {
  var _a;

  var iconBackground = {
    correct: {
      backgroundColor: '#00BF6F',
      borderColor: theme.border.correctColor
    },
    wrong: {
      backgroundColor: '#b32e22',
      borderColor: theme.border.wrongColor
    }
  };
  var highlightBackground = {
    backgroundColor: 'inherit',
    borderColor: theme.border.defaultColor
  }; // Quiz results uses the default font size

  var defaultFontSize = theme.fontSize.body;

  var _ref24 = (_a = theme.questionBody) !== null && _a !== void 0 ? _a : {},
      _ref24$fontFamily = _ref24.fontFamily,
      fontFamily = _ref24$fontFamily === void 0 ? 'inherit' : _ref24$fontFamily,
      _ref24$fontWeight = _ref24.fontWeight,
      fontWeight = _ref24$fontWeight === void 0 ? 'inherit' : _ref24$fontWeight,
      _ref24$fontStyle = _ref24.fontStyle,
      fontStyle = _ref24$fontStyle === void 0 ? 'inherit' : _ref24$fontStyle,
      _ref24$textDecoration = _ref24.textDecoration,
      textDecoration = _ref24$textDecoration === void 0 ? 'inherit' : _ref24$textDecoration,
      _ref24$highlightColor = _ref24.highlightColor,
      highlightColor = _ref24$highlightColor === void 0 ? 'inherit' : _ref24$highlightColor,
      _ref24$color = _ref24.color,
      color = _ref24$color === void 0 ? 'inherit' : _ref24$color;

  var textContainerFonts = {
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    textDecoration: textDecoration,
    highlightColor: highlightColor,
    color: color
  };
  return _defineProperty({
    componentContainer: {
      position: 'relative'
    },
    input: {
      opacity: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    labelContainer: function labelContainer(_ref25) {
      var highlight = _ref25.highlight;
      return {
        display: 'inline-block',
        position: 'relative',
        padding: [1, 8],
        margin: [4, 2],
        backgroundColor: highlight ? theme.correctAnswerHighlightColor : 'initial',
        borderRadius: 4
      };
    },
    textContainer: function textContainer(_ref26) {
      var highlight = _ref26.highlight;

      var _a;

      return _objectSpread(_objectSpread(_objectSpread({
        /* Right and left margin are both defined to account for RTL direction styling. */
        margin: [3, 30, 2],
        wordBreak: 'break-word',
        pointerEvents: 'none'
      }, textContainerFonts), highlight ? {
        fontWeight: (_a = theme.fontWeight.medium) !== null && _a !== void 0 ? _a : {}
      } : {}), {}, {
        fontSize: defaultFontSize
      });
    },
    iconContainer: function iconContainer(_ref27) {
      var icon = _ref27.icon,
          highlight = _ref27.highlight;
      return _objectSpread(_objectSpread({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 20,
        width: 20,
        margin: 2,
        borderRadius: 2,
        border: ['1px', 'solid', theme.border.defaultColor],
        position: 'absolute'
      }, icon ? iconBackground[icon] : {}), highlight && !icon ? highlightBackground : {});
    },
    textInputContainer: {
      margin: [5, 0, 0, 0]
    }
  }, "@media (min-width: ".concat(theme.breakpoints.smMin, ")"), {
    textInputContainer: {
      margin: [5, 0, 0, 32]
    }
  });
});

var QuizResultCheckBox = function QuizResultCheckBox(_ref29) {
  var optionText = _ref29.optionText,
      highlight = _ref29.highlight,
      icon = _ref29.icon,
      _ref29$hasTextInput = _ref29.hasTextInput,
      hasTextInput = _ref29$hasTextInput === void 0 ? false : _ref29$hasTextInput,
      textInputValue = _ref29.textInputValue,
      _ref29$textInputSize = _ref29.textInputSize,
      textInputSize = _ref29$textInputSize === void 0 ? 50 : _ref29$textInputSize,
      _ref29$textInputParag = _ref29.textInputParagraphLines,
      textInputParagraphLines = _ref29$textInputParag === void 0 ? 1 : _ref29$textInputParag,
      id = _ref29.id;

  var _useStyles$6 = useStyles$4({
    icon: icon,
    highlight: highlight
  }),
      iconContainer = _useStyles$6.iconContainer,
      componentContainer = _useStyles$6.componentContainer,
      labelContainer = _useStyles$6.labelContainer,
      textContainer = _useStyles$6.textContainer,
      textInputContainer = _useStyles$6.textInputContainer,
      input = _useStyles$6.input;

  var Icon = icon ? icons[icon] : icon;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: componentContainer
  }, React.createElement("label", {
    htmlFor: id,
    className: labelContainer
  }, React.createElement("input", {
    id: id,
    className: input,
    type: "checkbox",
    checked: !!icon,
    readOnly: true
  }), React.createElement("div", {
    className: iconContainer
  }, Icon && React.createElement(Icon, {
    isAriaHidden: true
  })), React.createElement("div", {
    className: textContainer
  }, React.createElement(RichText, {
    element: "span",
    text: optionText
  })), React.createElement(SrText, {
    icon: icon
  }))), React.createElement("div", {
    className: textInputContainer
  }, hasTextInput && (textInputParagraphLines <= 1 ? React.createElement(TextInput, {
    name: "otherOptionText",
    defaultValue: textInputValue,
    size: textInputSize,
    autoHeight: true,
    disabled: true
  }) : React.createElement(TextArea, {
    name: "otherOptionText",
    rows: textInputParagraphLines,
    defaultValue: textInputValue,
    cols: textInputSize,
    disabled: true
  }))));
};

var useStyles$3 = createUseStyles(function (theme) {
  var _a; // Quiz results uses the default font size


  var defaultFontSize = theme.fontSize.body;

  var _ref30 = (_a = theme.questionBody) !== null && _a !== void 0 ? _a : {},
      _ref30$fontFamily = _ref30.fontFamily,
      fontFamily = _ref30$fontFamily === void 0 ? 'inherit' : _ref30$fontFamily,
      _ref30$fontWeight = _ref30.fontWeight,
      fontWeight = _ref30$fontWeight === void 0 ? 'inherit' : _ref30$fontWeight,
      _ref30$fontStyle = _ref30.fontStyle,
      fontStyle = _ref30$fontStyle === void 0 ? 'inherit' : _ref30$fontStyle,
      _ref30$textDecoration = _ref30.textDecoration,
      textDecoration = _ref30$textDecoration === void 0 ? 'inherit' : _ref30$textDecoration,
      _ref30$highlightColor = _ref30.highlightColor,
      highlightColor = _ref30$highlightColor === void 0 ? 'inherit' : _ref30$highlightColor,
      _ref30$color = _ref30.color,
      color = _ref30$color === void 0 ? 'inherit' : _ref30$color;

  return {
    componentContainer: {
      position: 'relative'
    },
    labelContainer: {
      display: 'inline-block',
      position: 'relative',
      padding: 0,
      margin: [4, 2],
      borderRadius: 4
    },
    textContainer: {
      margin: [3, 0, 2],
      wordBreak: 'break-word',
      pointerEvents: 'none',
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontStyle: fontStyle,
      textDecoration: textDecoration,
      highlightColor: highlightColor,
      color: color,
      fontSize: defaultFontSize
    },
    textInputContainer: {
      margin: [5, 0, 0, 0]
    }
  };
});

var QuizResultComment = function QuizResultComment(_ref31) {
  var optionText = _ref31.optionText,
      textInputValue = _ref31.textInputValue,
      _ref31$textInputSize = _ref31.textInputSize,
      textInputSize = _ref31$textInputSize === void 0 ? 50 : _ref31$textInputSize,
      _ref31$textInputParag = _ref31.textInputParagraphLines,
      textInputParagraphLines = _ref31$textInputParag === void 0 ? 1 : _ref31$textInputParag,
      id = _ref31.id;

  var _useStyles$7 = useStyles$3(),
      componentContainer = _useStyles$7.componentContainer,
      labelContainer = _useStyles$7.labelContainer,
      textContainer = _useStyles$7.textContainer,
      textInputContainer = _useStyles$7.textInputContainer;

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: componentContainer
  }, React.createElement("label", {
    htmlFor: id,
    className: labelContainer
  }, React.createElement("div", {
    className: textContainer
  }, React.createElement(RichText, {
    element: "span",
    text: optionText
  })))), React.createElement("div", {
    className: textInputContainer
  }, textInputParagraphLines <= 1 ? React.createElement(TextInput, {
    id: id,
    name: "otherOptionText",
    defaultValue: textInputValue,
    size: textInputSize,
    autoHeight: true,
    disabled: true
  }) : React.createElement(TextArea, {
    id: id,
    name: "otherOptionText",
    rows: textInputParagraphLines,
    defaultValue: textInputValue,
    cols: textInputSize,
    disabled: true
  })));
};

var useStyles$2 = createUseStyles(function (theme) {
  var _a;

  var iconBackground = {
    correct: {
      backgroundColor: '#00BF6F',
      borderColor: theme.border.correctColor
    },
    wrong: {
      backgroundColor: '#b32e22',
      borderColor: theme.border.wrongColor
    }
  };
  var highlightBackground = {
    backgroundColor: 'inherit',
    borderColor: theme.border.defaultColor
  }; // Quiz results uses the default font size

  var defaultFrontSize = theme.fontSize.body;

  var _ref32 = (_a = theme.questionBody) !== null && _a !== void 0 ? _a : {},
      _ref32$fontFamily = _ref32.fontFamily,
      fontFamily = _ref32$fontFamily === void 0 ? 'inherit' : _ref32$fontFamily,
      _ref32$fontWeight = _ref32.fontWeight,
      fontWeight = _ref32$fontWeight === void 0 ? 'inherit' : _ref32$fontWeight,
      _ref32$fontStyle = _ref32.fontStyle,
      fontStyle = _ref32$fontStyle === void 0 ? 'inherit' : _ref32$fontStyle,
      _ref32$textDecoration = _ref32.textDecoration,
      textDecoration = _ref32$textDecoration === void 0 ? 'inherit' : _ref32$textDecoration,
      _ref32$highlightColor = _ref32.highlightColor,
      highlightColor = _ref32$highlightColor === void 0 ? 'inherit' : _ref32$highlightColor,
      _ref32$color = _ref32.color,
      color = _ref32$color === void 0 ? 'inherit' : _ref32$color;

  var textContainerFonts = {
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    fontStyle: fontStyle,
    textDecoration: textDecoration,
    highlightColor: highlightColor,
    color: color
  };
  return _defineProperty({
    componentContainer: {
      position: 'relative'
    },
    radioInput: {
      opacity: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    labelContainer: function labelContainer(_ref33) {
      var highlight = _ref33.highlight;
      return {
        display: 'inline-block',
        position: 'relative',
        padding: [1, 8],
        margin: [4, 2],
        backgroundColor: highlight ? theme.correctAnswerHighlightColor : 'initial',
        borderRadius: 13
      };
    },
    textContainer: function textContainer(_ref34) {
      var highlight = _ref34.highlight;

      var _a;

      return _objectSpread(_objectSpread(_objectSpread({
        /* Right and left margin are both defined to account for RTL direction styling. */
        margin: [3, 30, 2],
        wordBreak: 'break-word'
      }, textContainerFonts), highlight ? {
        fontWeight: (_a = theme.fontWeight.medium) !== null && _a !== void 0 ? _a : {}
      } : {}), {}, {
        fontSize: defaultFrontSize
      });
    },
    iconContainer: function iconContainer(_ref35) {
      var icon = _ref35.icon,
          highlight = _ref35.highlight;
      return _objectSpread(_objectSpread({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 20,
        width: 20,
        margin: 2,
        borderRadius: 10,
        border: ['1px', 'solid', theme.border.defaultColor],
        position: 'absolute'
      }, icon ? iconBackground[icon] : {}), highlight && !icon ? highlightBackground : {});
    },
    textInputContainer: {
      margin: [5, 0, 0, 0]
    }
  }, "@media (min-width: ".concat(theme.breakpoints.smMin, ")"), {
    textInputContainer: {
      margin: [5, 0, 0, 32]
    }
  });
});

var QuizResultRadioButton = function QuizResultRadioButton(_ref37) {
  var optionText = _ref37.optionText,
      highlight = _ref37.highlight,
      icon = _ref37.icon,
      _ref37$hasTextInput = _ref37.hasTextInput,
      hasTextInput = _ref37$hasTextInput === void 0 ? false : _ref37$hasTextInput,
      textInputValue = _ref37.textInputValue,
      _ref37$textInputSize = _ref37.textInputSize,
      textInputSize = _ref37$textInputSize === void 0 ? 50 : _ref37$textInputSize,
      _ref37$textInputParag = _ref37.textInputParagraphLines,
      textInputParagraphLines = _ref37$textInputParag === void 0 ? 1 : _ref37$textInputParag,
      id = _ref37.id;

  var _useStyles$8 = useStyles$2({
    highlight: highlight,
    icon: icon
  }),
      componentContainer = _useStyles$8.componentContainer,
      labelContainer = _useStyles$8.labelContainer,
      textContainer = _useStyles$8.textContainer,
      iconContainer = _useStyles$8.iconContainer,
      textInputContainer = _useStyles$8.textInputContainer,
      radioInput = _useStyles$8.radioInput;

  var Icon = icon ? icons[icon] : icon;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: componentContainer
  }, React.createElement("label", {
    htmlFor: id,
    className: labelContainer
  }, React.createElement("input", {
    id: id,
    className: radioInput,
    type: "radio",
    checked: !!icon,
    readOnly: true
  }), React.createElement("div", {
    className: iconContainer,
    "data-testid": "quiz-results-icon-container"
  }, Icon && React.createElement(Icon, {
    isAriaHidden: true
  })), React.createElement("div", {
    className: textContainer
  }, React.createElement(RichText, {
    element: "span",
    text: optionText
  })), React.createElement(SrText, {
    icon: icon
  }))), React.createElement("div", {
    className: textInputContainer
  }, hasTextInput && (textInputParagraphLines <= 1 ? React.createElement(TextInput, {
    name: "otherOptionText",
    defaultValue: textInputValue,
    size: textInputSize,
    autoHeight: true,
    disabled: true
  }) : React.createElement(TextArea, {
    name: "otherOptionText",
    rows: textInputParagraphLines,
    defaultValue: textInputValue,
    cols: textInputSize,
    disabled: true
  }))));
};

var useStyles$1 = createUseStyles(function (theme) {
  return {
    imageChoice: {
      display: 'inline-block',
      margin: [15, 0],
      padding: [0, 24, 0, 0]
    },
    componentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: 224,
      borderRadius: 2,
      border: '1px solid #D0D2D3'
    },
    imageContainer: {
      display: 'inline-block',
      width: '100%',
      height: 168,
      position: 'relative',
      backgroundColor: 'rgb(239, 239, 239)'
    },
    imageStyle: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: 'auto',
      maxHeight: '100%',
      maxWidth: '100%',
      height: 'auto',
      width: 'auto',
      pointerEvents: 'none'
    },
    captionStyle: function captionStyle(_ref38) {
      var highlight = _ref38.highlight;

      var _a;

      return {
        fontFamily: (_a = theme.questionBody.fontFamily) !== null && _a !== void 0 ? _a : {},
        display: 'block',
        backgroundColor: highlight ? theme.correctAnswerHighlightColor : 'initial',
        color: theme.answerColor,
        width: '100%',
        padding: [7, 9, 9, 7],
        fontWeight: highlight ? 500 : 'initial'
      };
    },
    srOnly: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0
    }
  };
});

var QuizResultImageChoice = function QuizResultImageChoice(_ref39) {
  var id = _ref39.id,
      _ref39$highlight = _ref39.highlight,
      highlight = _ref39$highlight === void 0 ? false : _ref39$highlight,
      _ref39$selected = _ref39.selected,
      selected = _ref39$selected === void 0 ? false : _ref39$selected,
      image = _ref39.image,
      _ref39$caption = _ref39.caption,
      caption = _ref39$caption === void 0 ? '' : _ref39$caption,
      correctMessage = _ref39.correctMessage,
      selectedMessage = _ref39.selectedMessage;

  var _useStyles$9 = useStyles$1({
    highlight: highlight
  }),
      imageChoice = _useStyles$9.imageChoice,
      componentContainer = _useStyles$9.componentContainer,
      imageContainer = _useStyles$9.imageContainer,
      imageStyle = _useStyles$9.imageStyle,
      captionStyle = _useStyles$9.captionStyle,
      srOnly = _useStyles$9.srOnly;

  var uniqId = useMemo(function () {
    return uniqueId('id-');
  }, []);
  var imageChoiceId = id || uniqId;
  var captionId = "caption-".concat(imageChoiceId);
  var selectedId = "selected-".concat(imageChoiceId);
  var highlightedId = "highlighted-".concat(imageChoiceId);
  var ariaDescribedBy = [];

  if (highlight) {
    ariaDescribedBy.push(highlightedId);
  }

  if (selected) {
    ariaDescribedBy.push(selectedId);
  }

  return React.createElement("div", {
    className: imageChoice
  }, React.createElement("div", {
    className: componentContainer
  }, React.createElement("div", {
    className: imageContainer
  }, React.createElement("img", {
    className: imageStyle,
    src: image.url,
    // Only add alt text if it's different than the label that describes it
    alt: caption === image.altText ? '' : image.altText,
    "aria-labelledby": caption || undefined,
    "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(' ') : undefined
  })), caption && React.createElement("span", {
    className: captionStyle,
    id: captionId
  }, caption), highlight && React.createElement("span", {
    className: srOnly,
    id: highlightedId
  }, correctMessage), selected && React.createElement("span", {
    className: srOnly,
    id: selectedId
  }, selectedMessage)));
};

var useStyles = createUseStyles(function (theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j; // Quiz results has a consistent font size


  var fontSize = theme.fontSize.body;
  return {
    componentContainer: {
      margin: [5, 0],
      fontFamily: (_b = (_a = theme.questionTitle) === null || _a === void 0 ? void 0 : _a.fontFamily) !== null && _b !== void 0 ? _b : {},
      fontStyle: (_d = (_c = theme.questionTitle) === null || _c === void 0 ? void 0 : _c.fontStyle) !== null && _d !== void 0 ? _d : {},
      fontWeight: (_f = (_e = theme.questionTitle) === null || _e === void 0 ? void 0 : _e.fontWeight) !== null && _f !== void 0 ? _f : {},
      color: ((_g = theme.questionTitle) === null || _g === void 0 ? void 0 : _g.color) || theme.questionColor,
      fontSize: fontSize,
      textDecoration: (_j = (_h = theme.questionTitle) === null || _h === void 0 ? void 0 : _h.textDecoration) !== null && _j !== void 0 ? _j : {}
    },
    scoreContainer: {
      display: 'inline'
    },
    feedbackContainer: {
      marginTop: 8,
      marginBottom: 0,
      wordWrap: 'wrap'
    },
    skippedBadge: {
      display: 'inline',
      padding: [2, 15],
      borderRadius: 15,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      marginLeft: 5
    }
  };
});
var COPY = defineMessages({
  POINT: {
    id: 'QuizResultScore.POINT',
    defaultMessage: 'point',
    description: '[Type: header][Vis: med] - total point of this quiz question'
  },
  POINTS: {
    id: 'QuizResultScore.POINTS',
    defaultMessage: 'points',
    description: '[Type: header][Vis: med] - total point of this quiz question'
  },
  SKIPPED: {
    id: 'QuizResultScore.SKIPPED',
    defaultMessage: 'Skipped',
    description: '[Type: header][Vis: med] - user skipped this quiz question'
  }
});

var QuizResultScore = function QuizResultScore(_ref40) {
  var score = _ref40.score,
      total = _ref40.total,
      feedback = _ref40.feedback,
      _ref40$skipped = _ref40.skipped,
      skipped = _ref40$skipped === void 0 ? false : _ref40$skipped;

  var _useStyles = useStyles(),
      componentContainer = _useStyles.componentContainer,
      scoreContainer = _useStyles.scoreContainer,
      feedbackContainer = _useStyles.feedbackContainer,
      skippedBadge = _useStyles.skippedBadge;

  return React.createElement("div", {
    className: componentContainer
  }, React.createElement("p", {
    className: scoreContainer
  }, "".concat(score, "/").concat(total, " "), React.createElement(T, {
    desc: total > 1 ? COPY.POINTS : COPY.POINT
  })), skipped && React.createElement("span", {
    className: skippedBadge
  }, React.createElement(T, {
    desc: COPY.SKIPPED
  })), feedback && React.createElement("p", {
    className: feedbackContainer,
    dangerouslySetInnerHTML: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      __html: sanitizeString(lodash_unescape(feedback))
    }
  }));
};
/**
 * Get the icon to indicator whether or not user got the answer correct or not
 * @param responded whether user selected the answer option or not
 * @param answerOptionPoints answer option points
 */


var getCorrectnessIndicatorIcon = function getCorrectnessIndicatorIcon(responded, answerOptionPoints) {
  if (!responded) {
    return undefined;
  }

  if (answerOptionPoints <= 0) {
    return 'wrong';
  }

  return 'correct';
};
/** Gets the icon and highlight for `idToSearch` */


var getIconAndHighlight = function getIconAndHighlight(answers, idToSearch, highlightCorrectAnswers) {
  var _ref41 = answers.find(function (_ref42) {
    var answer = _ref42.answer;
    return answer.id === idToSearch;
  }) || {},
      _ref41$points = _ref41.points,
      points = _ref41$points === void 0 ? 0 : _ref41$points,
      _ref41$responded = _ref41.responded,
      responded = _ref41$responded === void 0 ? false : _ref41$responded;

  var icon = getCorrectnessIndicatorIcon(responded, points);
  return {
    icon: icon,
    highlight: highlightCorrectAnswers && points > 0
  };
};
/** Picks feedback string based on user/total score */


var pickFeedback = function pickFeedback(feedback, userScore, totalScore) {
  if (userScore >= totalScore) {
    return feedback.correct;
  }

  if (userScore > 0) {
    return feedback.partial;
  }

  return feedback.incorrect;
};
/**
 * Calculate user score for a quiz question
 * @param quizAnswers Quiz or QuizImage results answers
 */


var getUserScore = function getUserScore(quizAnswers) {
  return quizAnswers.reduce(function (acc, cur) {
    return cur.responded ? acc + cur.points : acc;
  }, 0);
};
/** Helper Type Guard to filter our `undefined` */


var isNotUndefined = function isNotUndefined(a) {
  return a !== undefined;
};

var isPureQuizAnswer = function isPureQuizAnswer(answer) {
  return 'label' in answer.answer && 'visible' in answer.answer;
};
/** Filter `answers` to only regular Answers without invisible, "other" and "none of the above" */


var filterQuizAnswers = function filterQuizAnswers(answers) {
  var idsToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return answers.filter(isPureQuizAnswer).filter(function (_ref43) {
    var visible = _ref43.answer.visible;
    return visible;
  }).filter(function (a) {
    return !idsToFilter.filter(isNotUndefined).includes(a.answer.id);
  });
};

var isPureQuizImageAnswer = function isPureQuizImageAnswer(answer) {
  return 'label' in answer.answer && 'visible' in answer.answer && 'image' in answer.answer;
};
/** QuizImageAnswer without "other" and "none of the above" */


var filterOtherFromQuizImageAnswer = function filterOtherFromQuizImageAnswer(answers) {
  var idsToFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return answers.filter(isPureQuizImageAnswer).filter(function (_ref44) {
    var visible = _ref44.answer.visible;
    return visible;
  }).filter(function (a) {
    return !idsToFilter.filter(isNotUndefined).includes(a.answer.id);
  });
};

var ErrorFallback = function ErrorFallback(_ref45) {
  var error = _ref45.error;
  // TODO: temporary fallback ui (RAWR-773)
  return React.createElement(React.Fragment, null, React.createElement("h1", null, "Sorry.. there was an error"), React.createElement("p", null, error.message));
};

var withErrorBoundary = function withErrorBoundary(Component) {
  return function (props) {
    return React.createElement(reactErrorBoundary_umd.exports.ErrorBoundary, {
      FallbackComponent: ErrorFallback
    }, React.createElement(Component, Object.assign({}, props)));
  };
};

var CheckBox = function CheckBox(_ref46) {
  var id = _ref46.id,
      title = _ref46.title,
      questionNumber = _ref46.questionNumber,
      numberingEnabled = _ref46.numberingEnabled,
      highlightCorrectAnswers = _ref46.highlightCorrectAnswers,
      answerNoneOfTheAbove = _ref46.answerNoneOfTheAbove,
      answerLayoutColumns = _ref46.answerLayoutColumns,
      spacing = _ref46.spacing,
      answerOther = _ref46.answerOther,
      quizResults = _ref46.quizResults;
  var userScore = getUserScore(quizResults.answers);
  var totalScore = quizResults.totalPoints;
  var feedback = pickFeedback(quizResults.feedback, userScore, totalScore);
  /** Visible answers without "other" and "none of the above" */

  var regularAnswers = filterQuizAnswers(quizResults.answers, [answerNoneOfTheAbove === null || answerNoneOfTheAbove === void 0 ? void 0 : answerNoneOfTheAbove.id, answerOther === null || answerOther === void 0 ? void 0 : answerOther.id]);
  var isComment = (answerOther === null || answerOther === void 0 ? void 0 : answerOther.type) === 'COMMENT';

  var NoneOfTheAboveOption = function NoneOfTheAboveOption() {
    return (answerNoneOfTheAbove === null || answerNoneOfTheAbove === void 0 ? void 0 : answerNoneOfTheAbove.visible) ? React.createElement(QuizResultCheckBox, Object.assign({
      id: answerNoneOfTheAbove.id,
      optionText: answerNoneOfTheAbove.label
    }, getIconAndHighlight(quizResults.answers, answerNoneOfTheAbove.id, highlightCorrectAnswers))) : null;
  };

  var OtherOption = function OtherOption() {
    var _a, _b;

    if (!(answerOther === null || answerOther === void 0 ? void 0 : answerOther.visible)) {
      return null;
    }

    return isComment ? React.createElement(QuizResultComment, {
      id: answerOther.id,
      optionText: answerOther.label,
      textInputValue: (_a = quizResults.answerOther) === null || _a === void 0 ? void 0 : _a.textAnswer,
      textInputSize: answerOther.charsCount,
      textInputParagraphLines: answerOther.linesCount
    }) : React.createElement(QuizResultCheckBox, Object.assign({
      id: answerOther.id,
      optionText: answerOther.label,
      textInputValue: (_b = quizResults.answerOther) === null || _b === void 0 ? void 0 : _b.textAnswer,
      hasTextInput: true,
      textInputSize: answerOther.charsCount,
      textInputParagraphLines: answerOther.linesCount
    }, getIconAndHighlight(quizResults.answers, answerOther.id, !isComment && highlightCorrectAnswers)));
  };

  return React.createElement(QuestionFieldLayoutTemplate, {
    title: React.createElement(QuestionTitle, {
      id: id,
      heading: title,
      required: false,
      numbered: numberingEnabled,
      number: parseInt(questionNumber, 10),
      useDefaultFrontSize: true
    }),
    footer: React.createElement(QuizResultScore, {
      score: userScore,
      total: totalScore,
      feedback: feedback,
      skipped: false
    }),
    padding: spacing,
    clickShield: false,
    hasFooterPadding: true
  }, React.createElement(QuestionAnswerLayoutTemplate, {
    columns: answerLayoutColumns,
    noneOfTheAbove: !isComment ? React.createElement(NoneOfTheAboveOption, null) : null,
    other: React.createElement(OtherOption, null)
  }, regularAnswers.map(function (_ref47) {
    var answer = _ref47.answer,
        responded = _ref47.responded,
        points = _ref47.points;
    return React.createElement(QuizResultCheckBox, {
      key: answer.id,
      id: answer.id,
      optionText: answer.label,
      icon: getCorrectnessIndicatorIcon(responded, points),
      // Correct answers are expected to have a point value above 0
      // and should be highlighted.
      highlight: highlightCorrectAnswers && points > 0
    });
  }).concat(isComment ? [React.createElement(NoneOfTheAboveOption, {
    key: answerNoneOfTheAbove === null || answerNoneOfTheAbove === void 0 ? void 0 : answerNoneOfTheAbove.id
  })] : [])));
};

var CheckBox$1 = withErrorBoundary(CheckBox);

var MultipleChoice = function MultipleChoice(_ref48) {
  var id = _ref48.id,
      title = _ref48.title,
      questionNumber = _ref48.questionNumber,
      numberingEnabled = _ref48.numberingEnabled,
      highlightCorrectAnswers = _ref48.highlightCorrectAnswers,
      answerNoneOfTheAbove = _ref48.answerNoneOfTheAbove,
      answerLayoutColumns = _ref48.answerLayoutColumns,
      spacing = _ref48.spacing,
      answerOther = _ref48.answerOther,
      quizResults = _ref48.quizResults;
  var userScore = getUserScore(quizResults.answers);
  var totalScore = quizResults.totalPoints;
  var feedback = pickFeedback(quizResults.feedback, userScore, totalScore);
  /** Visible answers without "other" and "none of the above" */

  var regularAnswers = filterQuizAnswers(quizResults.answers, [answerNoneOfTheAbove === null || answerNoneOfTheAbove === void 0 ? void 0 : answerNoneOfTheAbove.id, answerOther === null || answerOther === void 0 ? void 0 : answerOther.id]);
  var isComment = (answerOther === null || answerOther === void 0 ? void 0 : answerOther.type) === 'COMMENT';

  var NoneOfTheAboveOption = function NoneOfTheAboveOption() {
    return (answerNoneOfTheAbove === null || answerNoneOfTheAbove === void 0 ? void 0 : answerNoneOfTheAbove.visible) ? React.createElement(QuizResultRadioButton, Object.assign({
      id: answerNoneOfTheAbove.id,
      optionText: answerNoneOfTheAbove.label
    }, getIconAndHighlight(quizResults.answers, answerNoneOfTheAbove.id, highlightCorrectAnswers))) : null;
  };

  var OtherOption = function OtherOption() {
    var _a, _b;

    if (!(answerOther === null || answerOther === void 0 ? void 0 : answerOther.visible)) {
      return null;
    }

    return isComment ? React.createElement(QuizResultComment, {
      id: answerOther.id,
      optionText: answerOther.label,
      textInputValue: (_a = quizResults.answerOther) === null || _a === void 0 ? void 0 : _a.textAnswer,
      textInputSize: answerOther.charsCount,
      textInputParagraphLines: answerOther.linesCount
    }) : React.createElement(QuizResultRadioButton, Object.assign({
      id: answerOther.id,
      optionText: answerOther.label,
      textInputValue: (_b = quizResults.answerOther) === null || _b === void 0 ? void 0 : _b.textAnswer,
      hasTextInput: true,
      textInputSize: answerOther.charsCount,
      textInputParagraphLines: answerOther.linesCount
    }, getIconAndHighlight(quizResults.answers, answerOther.id, !isComment && highlightCorrectAnswers)));
  };

  return React.createElement(QuestionFieldLayoutTemplate, {
    title: React.createElement(QuestionTitle, {
      id: id,
      heading: title,
      required: false,
      numbered: numberingEnabled,
      number: parseInt(questionNumber, 10),
      useDefaultFrontSize: true
    }),
    footer: React.createElement(QuizResultScore, {
      score: userScore,
      total: totalScore,
      feedback: feedback,
      skipped: false
    }),
    padding: spacing,
    clickShield: false,
    hasFooterPadding: true
  }, React.createElement(QuestionAnswerLayoutTemplate, {
    columns: answerLayoutColumns,
    noneOfTheAbove: !isComment ? React.createElement(NoneOfTheAboveOption, null) : null,
    other: React.createElement(OtherOption, null)
  }, regularAnswers.map(function (answerOption) {
    var answer = answerOption.answer,
        points = answerOption.points,
        responded = answerOption.responded;
    var icon = getCorrectnessIndicatorIcon(responded, points);
    return React.createElement(QuizResultRadioButton, {
      key: answer.id,
      id: answer.id,
      optionText: answer.label,
      icon: icon,
      // Correct answers are expected to have a point value above 0
      // and should be highlighted.
      highlight: highlightCorrectAnswers && points > 0
    });
  }).concat(isComment && answerNoneOfTheAbove ? [React.createElement(NoneOfTheAboveOption, {
    key: answerNoneOfTheAbove.id
  })] : [])));
};

var MultipleChoice$1 = withErrorBoundary(MultipleChoice);

var ImageChoice = function ImageChoice(_ref49) {
  var id = _ref49.id,
      title = _ref49.title,
      questionNumber = _ref49.questionNumber,
      highlightCorrectAnswers = _ref49.highlightCorrectAnswers,
      numberingEnabled = _ref49.numberingEnabled,
      answerNoneOfTheAbove = _ref49.answerNoneOfTheAbove,
      quizResults = _ref49.quizResults,
      isManyAnswers = _ref49.isManyAnswers;
  var userScore = getUserScore(quizResults.answers);
  var totalScore = quizResults.totalPoints;
  var feedback = pickFeedback(quizResults.feedback, userScore, totalScore);

  var NoneOfTheAboveOption = function NoneOfTheAboveOption() {
    var NoneOfTheAboveComponent = isManyAnswers ? QuizResultCheckBox : QuizResultRadioButton;
    return answerNoneOfTheAbove && answerNoneOfTheAbove.visible ? React.createElement(NoneOfTheAboveComponent, Object.assign({
      id: answerNoneOfTheAbove.id,
      optionText: answerNoneOfTheAbove.label
    }, getIconAndHighlight(quizResults.answers, answerNoneOfTheAbove.id, highlightCorrectAnswers))) : null;
  };
  /** Answers without "none of the above" */


  var regularAnswers = filterOtherFromQuizImageAnswer(quizResults.answers, [answerNoneOfTheAbove === null || answerNoneOfTheAbove === void 0 ? void 0 : answerNoneOfTheAbove.id]);
  return React.createElement(QuestionFieldLayoutTemplate, {
    title: React.createElement(QuestionTitle, {
      id: id,
      heading: title,
      required: false,
      numbered: numberingEnabled,
      number: parseInt(questionNumber, 10),
      useDefaultFrontSize: true
    }),
    footer: React.createElement(QuizResultScore, {
      score: userScore,
      total: totalScore,
      feedback: feedback,
      skipped: false
    }),
    clickShield: false,
    hasFooterPadding: true
  }, React.createElement(QuestionAnswerLayoutTemplate, {
    columns: "horizontal",
    noneOfTheAbove: React.createElement(NoneOfTheAboveOption, null),
    adjustToContent: true
  }, regularAnswers.map(function (answerOption) {
    var answer = answerOption.answer,
        points = answerOption.points,
        responded = answerOption.responded;
    return React.createElement(QuizResultImageChoice, {
      key: answer.id,
      id: answer.id,
      image: answer.image,
      caption: answer.label,
      selected: responded,
      // Correct answers are expected to have a point value above 0
      // and should be highlighted.
      highlight: highlightCorrectAnswers && points > 0
    });
  })));
};

var ImageChoice$1 = withErrorBoundary(ImageChoice);
export { CheckBox$1 as CheckBox, ImageChoice$1 as ImageChoice, MultipleChoice$1 as MultipleChoice };